import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface GaAskDialogData {
    title: string;
    content: string[];
    actions: {
        [actionName: string]: {
            text: string;
            returnValue: any;
            color?: string;
        }
    };
    initFocusActionKey?: string;
    html?: boolean;
}

@Component({
    selector: 'ga-ask-dialog',
    templateUrl: './ask-dialog.component.html',
    styleUrls: ['./ask-dialog.component.scss']
})
export class GaAskDialogComponent {

    public keys: string[];
    public initFocusKey: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: GaAskDialogData,
        private dialogRef: MatDialogRef<GaAskDialogComponent>
    ) {
        this.keys = Object.keys(this.data.actions).filter(key => this.data.actions.hasOwnProperty(key));
        if (this.keys.length) {
            if (this.data.initFocusActionKey && this.data.actions.hasOwnProperty(this.data.initFocusActionKey)) {
                this.initFocusKey = this.data.initFocusActionKey;
            } else {
                this.initFocusKey = this.keys[this.keys.length - 1];
            }
        }
    }

    public onClose(key: string): void {
        this.dialogRef.close(this.data.actions[key].returnValue);
    }
}
